var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 80,
    viewBox: "0 0 75 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.5562 18.7781C55.5562 29.1489 47.1489 37.5562 36.7781 37.5562C26.4072 37.5562 18 29.1489 18 18.7781C18 8.40723 26.4072 0 36.7781 0C47.1489 0 55.5562 8.40723 55.5562 18.7781ZM63.7124 48.7197C70.6534 54.9135 74.5573 63.4683 74.7529 72.8766C71.1166 74.3545 56.0063 80 37.376 80C20.1473 80 3.92113 74.3211 0 72.8464C0.203916 63.4498 4.10529 54.907 11.0397 48.7197C17.9403 42.5636 27.2924 39.1734 37.376 39.1734C47.4597 39.1734 56.8117 42.5636 63.7124 48.7197Z",
    fill: "url(#paint0_linear_190_1999)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_190_1999",
    x1: 27.5,
    y1: 17.5,
    x2: 56,
    y2: 68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7ED9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.970505,
    stopColor: "#F6D421"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellow);
export default __webpack_public_path__ + "static/media/yellow.20dc10dada3ed10d380a76efb2b4f582.svg";
export { ForwardRef as ReactComponent };